import { STORAGE_KEYS } from "@lib/config/storageKeys";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Initialize theme from localStorage or default to 'neo-tim-dark'
    if (typeof window !== "undefined") {
      return localStorage.getItem(STORAGE_KEYS.UI.THEME) || "neo-tim-dark";
    }
    return "neo-tim-dark";
  });

  useEffect(() => {
    // Apply theme to the document's <html> element
    document.documentElement.setAttribute("data-theme", theme);
    // Persist theme to localStorage
    localStorage.setItem(STORAGE_KEYS.UI.THEME, theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prevTheme) => {
      const newTheme = prevTheme === "neo-tim-dark" ? "neo-tim-light" : "neo-tim-dark";
      return newTheme;
    });
  }, []);

  const value = useMemo(() => ({ theme, toggleTheme }), [theme, toggleTheme]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
